"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _icons = _interopRequireDefault(require("cccisd-icons/scripts/icons.json"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PER_PAGE = 120;
var Icons = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Icons, _React$Component);
  function Icons() {
    var _this;
    _classCallCheck(this, Icons);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Icons, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      filter: '',
      currentPage: 1
    });
    _defineProperty(_assertThisInitialized(_this), "getFilteredList", function () {
      if (!_this.state.filter) {
        return _icons["default"];
      }
      return _icons["default"].filter(function (item) {
        return item.tags.join(',').includes(_this.state.filter);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (e) {
      _this.setState({
        filter: e.target.value,
        currentPage: 1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (iconName) {
      var icon = _icons["default"].find(function (item) {
        return item.name === iconName;
      });
      var code = icon.paths.map(function (path) {
        return "<path d=\"".concat(path, "\" />");
      }).join('');

      // we need to include non-visible span, otherwise tinymce strip outer span
      var svg = "<span class=\"mceNonEditable\"><svg class=\"cccisd-wysiwyg-icon\" viewBox=\"".concat(icon.viewBox, "\"><g>").concat(code, "</g></svg><span style=\"display:none;\">*</span></span>");
      _this.props.insertContent(svg, _this.props.meta);
    });
    return _this;
  }
  _createClass(Icons, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var filteredList = this.getFilteredList();
      var start = (this.state.currentPage - 1) * PER_PAGE;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        value: this.state.filter,
        onChange: this.handleFilterChange,
        style: {
          maxWidth: '200px'
        },
        placeholder: "Search",
        className: "form-control",
        autoFocus: true
      })), filteredList.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].iconWrapper
      }, filteredList.slice(start, start + PER_PAGE).map(function (icon) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: icon.name,
          className: _style["default"].icon,
          onClick: function onClick() {
            return _this2.onSubmit(icon.name);
          }
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          viewBox: icon.viewBox
        }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (path, index) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: index,
            d: path
          });
        }))));
      })) : /*#__PURE__*/_react["default"].createElement("div", null, "No icon found"), filteredList.length > PER_PAGE && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        currentPage: this.state.currentPage,
        total: Math.ceil(filteredList.length / PER_PAGE),
        onPageChange: function onPageChange(page) {
          return _this2.setState({
            currentPage: page
          });
        }
      })));
    }
  }]);
  return Icons;
}(_react["default"].Component);
_defineProperty(Icons, "propTypes", {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  insertContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string,
  closeModal: _propTypes["default"].func
});